import { render, staticRenderFns } from "./StudentInformation.vue?vue&type=template&id=2d65a5d4&scoped=true&"
import script from "./StudentInformation.vue?vue&type=script&lang=js&"
export * from "./StudentInformation.vue?vue&type=script&lang=js&"
import style0 from "./StudentInformation.vue?vue&type=style&index=0&id=2d65a5d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d65a5d4",
  null
  
)

export default component.exports